import React from 'react';
import PostingElement from './PostingElement';

export default function NewThreadShort(props) {

	const x = props.x;
	const wafId = "new-thread-short";

	React.useEffect(() => {

		// if (! x.was.isMobileDevice()) x.waf.focus('new-thread-short', 'posting');

		const handleKey = (event) => {
			if (event.key === '@' && event.target.id === 'new-thread-short-new-posting-short') {
				const forumId = x.wam.getForumId();
				x.wam[forumId].showDialogNewThread();
				x.wam[forumId].setTab('postings'); // Funktion wird in tabs.js definiert
				x.wam.activate(forumId);

				event.preventDefault();
			}
		}

		window.addEventListener("keydown", handleKey);


		return () => {
			window.removeEventListener("keydown", handleKey);
		}

	}, [props, x.was, x.wam]);

	if (x.was.windowWidth > 1000) {
		x.$('#new-posting-short').trigger("focus");
	}

	function saveNewThread(event) {
		event.preventDefault();
		var forumId;
		if (x.wam.isForum()) {
			forumId = x.wam.current;
		}
		else {
			forumId = 'forum'
			x.wam.activate(forumId);
			// x.was.activateModule(forumId);
		}
		const newThread = x.waf.get(wafId, 'new-posting-short');
		if (newThread.trim() > '') {
			x.wam[forumId].closeDialogs();
			// console.log('Save new Posting: ' + newThread);
			x.waf.set(forumId + '-new-thread', 'posting', newThread);
			x.waf[forumId + '-new-thread'].send();
			x.waf.select(wafId, 'new-posting-short');
		}
	}

	/*
	async function newThreadFromClipboard() {
		const cb = await navigator.clipboard.read();
		const type = cb[0].types[0].substring(0, 4).toLowerCase();
		if (type === 'text') {
			const text = await navigator.clipboard.readText();
			pasteText(text);
		}
		if (type === 'image') {
			const text = await navigator.clipboard.readText();
			pasteText(text);
		}
	}
	*/

	return (
		<div id="new-thread-short" className={` new-thread-short `}>
			<form className={`form-new-thread-short me-2 ${props.newThreadClass}`} onSubmit={e => saveNewThread(e)}>
				<PostingElement
					id="new-posting-short"
					x={x}
					wafId={wafId}
					classes="new-posting new-posting-short"
					maxLength="500"
					placeholder="Neuer Beitrag"
				/>
			</form>
		</div>
	);


}
